import commonService from './common.service';
import phonebuyService from './phonebuy.service';
import phonefixService from './phonefix.service';
import userService from './user.service';
import settingService from './setting.service';

export default {
  commonService,
  phonebuyService,
  phonefixService,
  userService,
  settingService,
}
